export default "__VITE_ASSET__CjleGNWK__"